<!-- cSpell:ignore заметки Новая заметка Добавить Удалить VITE -->
<template>
  <div>
    <h2 class="text-lg font-bold mb-4">Мои заметки</h2>

    <form @submit.prevent="addNote" class="flex mb-4">
      <input v-model="newNote" placeholder="Новая заметка" class="border flex-1 p-2" />
      <button class="bg-blue-500 text-white px-4 ml-2 rounded">Добавить</button>
    </form>

    <ul>
      <li v-for="note in notes" :key="note.id" class="flex justify-between border-b py-2">
        {{ note.text }}
        <button @click="deleteNote(note.id)" class="text-red-500">Удалить</button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

defineOptions({
  name: 'NotesView'
});

interface Note {
  id: number;
  text: string;
}

const router = useRouter();
const newNote = ref<string>('');
const notes = ref<Note[]>([]);

const fetchNotes = async (): Promise<void> => {
  const res = await fetch(`${import.meta.env.VITE_API_URL}/notes`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  if (res.ok) {
    notes.value = await res.json();
  } else if (res.status === 401 || res.status === 403) {
    localStorage.removeItem('token');
    router.push('/login');
  }
};

const addNote = async (): Promise<void> => {
  if (!newNote.value.trim()) return;
  await fetch(`${import.meta.env.VITE_API_URL}/notes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({ text: newNote.value }),
  });
  newNote.value = '';
  await fetchNotes();
};

const deleteNote = async (id: number): Promise<void> => {
  await fetch(`${import.meta.env.VITE_API_URL}/notes/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  await fetchNotes();
};

onMounted(async () => {
  await fetchNotes();
});
</script>
